import { useMutation } from '@tanstack/react-query';
import type { CreateDirectorMessageRequest } from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

export function useSendDirector() {
  return useMutation<void, unknown, CreateDirectorMessageRequest>({
    mutationFn: async (payload) => {
      await api.post('/director-messages', payload);
    },
  });
}
